module.exports = __webpack_public_path__ + "static/media/Banner3.a6ccc4a8.jpg";